import { useState } from "react";
import HideColumnsMenuStyles from "./HideColumnsMenuStyles";
import { Menu, Typography, MenuItem, Checkbox, IconButton, Box, useTheme, Button } from "@mui/material";
import CustomIcon from "components/CustomIcon";
import icons from "enums/icons";

const HideColumnsMenu = ({
    icon,
    items,
    onClickItem,
    disabled,
    isICReport,
    disableReset,
    onResetColumns,
}: {
    icon: React.ReactNode;
    items: {
        id: string | number;
        name: string;
        isHidden?: boolean;
    }[];
    onClickItem: (ev: React.MouseEvent<HTMLLIElement, MouseEvent>, itemId: string | number) => void;
    disabled?: boolean;
    isICReport?: boolean;
    disableReset?: boolean;
    onResetColumns?: () => void;
}) => {
    const classes = HideColumnsMenuStyles();
    const theme = useTheme();

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const visibleColumns = items.filter((col) => !col.isHidden);

    const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton disabled={disabled} size="small" onClick={handleOpenMenu} sx={{ p: 0 }}>
                {icon}
            </IconButton>

            <Menu
                className={classes.menuWrapper}
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseMenu}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                {isICReport ? (
                    <li className={classes.itemHeader}>
                        <Typography className={classes.itemHeaderTitle}>Choose columns to display (max 8)</Typography>
                        <Typography className={classes.itemHeaderSubtitle}>
                            Showing {visibleColumns.length} of 8
                        </Typography>
                    </li>
                ) : (
                    <li className={classes.itemHeader}>
                        <Typography className={classes.itemHeaderTitle}>Manage Columns</Typography>
                        <Typography className={classes.itemHeaderSubtitle}>{visibleColumns.length} Selected</Typography>
                    </li>
                )}

                {isICReport && visibleColumns.length >= 8 && (
                    <Box>
                        <Typography sx={{ padding: 1, color: theme.palette.error.dark }}>
                            Remove a column to add another
                        </Typography>
                    </Box>
                )}

                {items.map((item) => {
                    const isVisible = !item.isHidden;
                    const disableItem = isICReport && visibleColumns.length >= 8 && !isVisible;
                    return (
                        <MenuItem
                            key={item.id}
                            className={classes.menuItem}
                            onClick={(ev) => onClickItem(ev, item.id)}
                            disabled={disableItem}
                        >
                            <Checkbox size="small" checked={!item.isHidden} />
                            <Typography>{item.name}</Typography>
                        </MenuItem>
                    );
                })}

                {isICReport && (
                    <Box display="flex" alignItems="center" justifyContent="end">
                        <Button
                            variant="text"
                            disabled={disableReset}
                            startIcon={<CustomIcon icon={icons.iconRefresh} />}
                            onClick={onResetColumns}
                            className={classes.resetButton}
                        >
                            <Typography sx={{ fontSize: 13 }}>Reset</Typography>
                        </Button>
                    </Box>
                )}
            </Menu>
        </>
    );
};

export default HideColumnsMenu;
